export default __webpack_public_path__ + "static/media/EventsDefault.909ec1e5.png";